import { createApp } from 'vue';
import FavoriteButton from '../widgets/favorite-button.vue';

const SELECTOR = '[data-favorite-button]';

export function init() {
    const elements = document.querySelectorAll(SELECTOR);

    for (const element of elements) {
        const data = JSON.parse(element.dataset.favoriteButton || '{}');

        const attrs = {};

        for (const { name, value } of element.attributes) {
            if (!name.startsWith('data-')) {
                attrs[name] = value;
            }
        }

        const fragment = document.createDocumentFragment();

        createApp(FavoriteButton, { data, ...attrs }).mount(fragment);

        element.parentNode.replaceChild(fragment, element);
    }
}
